/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * LiveEventBase
 * auto generated base class for the model LiveEventModel.
 */
export const LiveEventModelBase = ModelBase.named('LiveEvent')
  .props({
    __typename: types.optional(types.literal('LiveEvent'), 'LiveEvent'),
    date: types.union(types.undefined, types.string),
    eventName: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class LiveEventModelSelector extends QueryBuilder {
  get date() {
    return this.__attr('date')
  }
  get eventName() {
    return this.__attr('eventName')
  }
}
export function selectFromLiveEvent() {
  return new LiveEventModelSelector()
}

export const liveEventModelPrimitives = selectFromLiveEvent().date.eventName
